/* eslint-disable */

import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import RaindropCopyrightDeclaration from "../../../ui-components/raindrop-copyright-declaration/raindrop-copyright-declaration";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import { Link } from "react-router-dom";
import { URL_RAINDROP, URL_STRATUS } from "../../../services/constants";
import SocialLinkInstagram from "../../../ui-components/social-link-instagram/social-link-instagram.tsx";
import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";
import { Size } from "../../../logic/enums.ts";
import RaindropTitle from "../../../ui-components/raindrop-title/raindrop-title.tsx";

const WebsiteTopBar = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row w-full items-center  justify-center px-6 z-10 max-w-4xl  ">
      <RaindropClickable onClick={() => navigate("/stratus")}>
        <RaindropTitle size={Size.Medium} isPrimary={true} />
      </RaindropClickable>

      <div className="hidden md:flex w-full flex-row-reverse flex-row gap-2 items-center">
        <RaindropButton
          style={ButtonStyle.Secondary}
          title={"About Us"}
          to={`${URL_STRATUS}/stratus/about-us`}
        />
        <RaindropButton
          style={ButtonStyle.Secondary}
          title={"Blog"}
          to={`${URL_STRATUS}/stratus/blog`}
        />
        <RaindropButton
          style={ButtonStyle.Secondary}
          title={"Explore"}
          to={`${URL_RAINDROP}`}
        />
        {/* <RaindropButton
          style={ButtonStyle.Secondary}
          title={"Organisations"}
          to={`${URL_STRATUS}/stratus/for-organisations`}
        /> */}

        {/* <RaindropButton
          style={ButtonStyle.Primary}
          size={Size.Large}
          title={"Sign Up"}
          to={`${URL_RAINDROP}`}
          target="_blank"
          rel="noopener noreferrer"
        /> */}
      </div>
    </div>
  );
};

const ContentFooter = () => {
  return (
    <div id="content-footer" className="flex flex-col gap-16 w-full p-4">
      <div className="flex flex-col md:flex-row w-full gap-8 md:justify-between">
        <div className="flex flex-col gap-2 ">
          <h4 className="font-bold text-color-dark-text-secondary">Explore</h4>
          <Link
            to={"/stratus"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Raindrop for Users
          </Link>
          <Link
            to={"/stratus/for-organisations"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Raindrop for Organisations
          </Link>
        </div>
        <div className="flex flex-col gap-2 ">
          <h4 className="font-bold text-color-dark-text-secondary">Support</h4>
          <Link
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
            to={"/stratus/about-us"}
          >
            About Us
          </Link>
          <Link
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
            to={"mailto:rhaz.solomon@theraindropcompany.com"}
          >
            Contact Us
          </Link>
          <Link
            to={"/stratus/frequently-asked-questions"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Frequently Asked Questions
          </Link>
        </div>

        <div className="flex flex-col gap-2">
          <div className="font-bold text-color-dark-text-secondary">Legal</div>
          <Link
            to={"/stratus/terms-and-conditions"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Terms and Conditions
          </Link>
          <Link
            to={"/stratus/privacy-policy"}
            className="text-sm transition-all text-color-dark-text-tertiary hover:text-color-dark-text-primary"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

const AstriskFooter = () => {
  return (
    <div className="flex flex-col gap-4 w-full p-4">
      <div className="flex flex-col gap-2">
        <div className=" text-color-dark-text-tertiary">
          * The Raindrop Company is a trading name of The Raindrop Group
          Limited, a company registered in England and Wales with company number
          15379435
        </div>
      </div>
    </div>
  );
};

const StratusBase = () => {
  // Theme
  const [theme, setTheme] = useState(
    window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = () => {
      setTheme(mediaQuery.matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", handleChange);

    // Cleanup function:
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  // Component
  return (
    <div className={theme}>
      <div
        id={"raindrop-website-global"}
        className={
          "flex flex-col items-center text-color-text-primary dark:text-color-dark-text-primary bg-color-background-primary dark:bg-color-dark-background-primary  pb-10 relative no-scrollbar"
        }
      >
        <div
          id="raindrop-website-inner"
          className={"flex flex-col w-full  max-w-5xl px-4 no-scrollbar"}
        >
          <WebsiteTopBar />
          <div className="flex w-full min-h-[500px]">
            <Outlet />
          </div>
          <div className="flex flex-col gap-6 pt-10">
            <RaindropDivider />
            <SocialLinkInstagram />
            <AstriskFooter />
            <ContentFooter />
            <RaindropCopyrightDeclaration />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StratusBase;
